// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ArticleRedactorAudioPlayer__container-c373cd {
  box-sizing: border-box;
  display: flex;
  min-height: 62px;
  border-radius: 16px;
}

.ArticleRedactorAudioPlayer__player-a604d3 {
  flex: 0 0 auto;
  border-radius: 100%;
  cursor: pointer;
}

.ArticleRedactorAudioPlayer__controls-container-eb03ab {
  flex: 1 1 auto;
  overflow: auto;
  margin-inline-start: 8px;
}

.ArticleRedactorAudioPlayer__description-c4445f {
  display: flex;
  justify-content: space-between;
}

.ArticleRedactorAudioPlayer__title-ae2fbd {
  color: var(--base-110);
  font: var(--font-button);
  letter-spacing: var(--font-spacing-button);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ArticleRedactorAudioPlayer__slider-container-df0138 {
  flex: 1 1 auto;
  position: relative;
  height: 2px;
  margin-top: 6px;
}

.ArticleRedactorAudioPlayer__caption-bc37dd {
  color: var(--base-80);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/Article/ArticleRedactor/Payloads/Audio/ArticleRedactorAudioPlayer/ArticleRedactorAudioPlayer.styles.m.css"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;EACA,cAAA;EACA,wBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AACF;;AAEA;EACE,qBAAA;EACA,4BAAA;EACA,8CAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF","sourcesContent":[".container {\n  box-sizing: border-box;\n  display: flex;\n  min-height: 62px;\n  border-radius: 16px;\n}\n\n.player {\n  flex: 0 0 auto;\n  border-radius: 100%;\n  cursor: pointer;\n}\n\n.controls-container {\n  flex: 1 1 auto;\n  overflow: auto;\n  margin-inline-start: 8px;\n}\n\n.description {\n  display: flex;\n  justify-content: space-between;\n}\n\n.title {\n  color: var(--base-110);\n  font: var(--font-button);\n  letter-spacing: var(--font-spacing-button);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.slider-container {\n  flex: 1 1 auto;\n  position: relative;\n  height: 2px;\n  margin-top: 6px;\n}\n\n.caption {\n  color: var(--base-80);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ArticleRedactorAudioPlayer__container-c373cd`,
	"player": `ArticleRedactorAudioPlayer__player-a604d3`,
	"controls-container": `ArticleRedactorAudioPlayer__controls-container-eb03ab`,
	"controlsContainer": `ArticleRedactorAudioPlayer__controls-container-eb03ab`,
	"description": `ArticleRedactorAudioPlayer__description-c4445f`,
	"title": `ArticleRedactorAudioPlayer__title-ae2fbd`,
	"slider-container": `ArticleRedactorAudioPlayer__slider-container-df0138`,
	"sliderContainer": `ArticleRedactorAudioPlayer__slider-container-df0138`,
	"caption": `ArticleRedactorAudioPlayer__caption-bc37dd`
};
module.exports = ___CSS_LOADER_EXPORT___;
